import { render, staticRenderFns } from "./UsersCrudPage.vue?vue&type=template&id=aaa8e7fc&"
import script from "./UsersCrudPage.vue?vue&type=script&lang=js&"
export * from "./UsersCrudPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports